const setImportSheetModalState = (state, payload) => {
  state.openModalImportSheet = payload
}

const setAIRequestLimitModalState = (state, payload) => {
  state.isAIRequestLimitModalVisible = payload
}

const setShowModalTemplateLibraryState = (state, payload) => {
  state.isShowModalTemplateLibrary = payload
}

const setInitialTemplateLibraryCategoryIdState = (state, payload) => {
  state.initialTemplateLibraryCategoryId = payload
}

const setTemplateLibraryDeepLinkSourceState = (state, payload) => {
  state.templateLibraryDeepLinkSource = payload
}

export default {
  setImportSheetModalState,
  setAIRequestLimitModalState,
  setShowModalTemplateLibraryState,
  setInitialTemplateLibraryCategoryIdState,
  setTemplateLibraryDeepLinkSourceState,
}
